<template>
  <div class="position-r width100 height100">
    <div id="chartMap" class="chart"></div>
    <ModalChargeDetail ref="ModalChargeDetail"/>
    <ModalSwapDetail ref="ModalSwapDetail"/>
    <ModalLiveVideo ref="ModalLiveVideo"/>
    <MultipleLiveVideo ref="gasMultiLiveVideo"/>
    <PhotovoltaicDetail ref="PhotovoltaicDetail"/>
  </div>
</template>

<script>
import ModalChargeDetail from "@/components/ModalChargeDetail/ModalChargeDetail.vue";
import ModalLiveVideo from "@/components/ModalLiveVideo/ModalLiveVideo.vue";
import MultipleLiveVideo from "@/components/MultipleLiveVideo/MultipleLiveVideo.vue";
import PhotovoltaicDetail from "@/components/PhotovoltaicDetail/PhotovoltaicDetail.vue";
import {Loading} from "element-ui";
import ModalSwapDetail from "@/components/ModalSwapDetail/ModalSwapDetail.vue";
import icon_conver_on from "@/assets/image/icon_converter_on.png";

export default {
  components: {ModalSwapDetail, ModalLiveVideo, ModalChargeDetail,MultipleLiveVideo,PhotovoltaicDetail},
  data() {
    return {
      chart: null,
      flag: false,
      timer: null,
      sourceData: [],
      chargeData: [],
      gasData: [],
      converterStation:[],
      gasTotal:0,
      fireGasStation:[],
      gasolineData: [],
      gasCameraList: [],
      gfStation:[]
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.chart = this.$echarts.init(document.getElementById("chartMap"));
      this.getData();
    });
  },
  methods: {
    bindEvents() {
      this.chart.on("click", ({data}) => {
        if (data.type === "充电站") {
          this.$refs["ModalChargeDetail"].open(data);
        } else if(data.type === '加油站' && data.sxtdz){
          let that = this;
          const loading = Loading.service({
            lock: true,
            text: "正在加载监控信息..",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          Promise.allSettled([ this.getGasCameraList(data.sxtdz)]).then(() => {
               loading.close();
             that.openGasVide(data.mc);
          });
        }else if(data.type === "换电站"){
          this.$refs["ModalSwapDetail"].open(data);
        }else if(data.type === '光伏站'){
          this.$refs["PhotovoltaicDetail"].open(data);
        }
      });
      this.chart.on("mouseover", (e) => {
        if (e.componentSubType === "scatter") {
          clearInterval(this.timer);

          this.chart.dispatchAction({
            type: "downplay"
          });

          this.chart.dispatchAction({
            type: "hideTips"
          });

          this.chart.dispatchAction({
            type: "highlight",
            seriesIndex: e.seriesIndex,
            dataIndex: e.dataIndex
          });

          this.chart.dispatchAction({
            type: "showTip",
            seriesIndex: e.seriesIndex,
            dataIndex: e.dataIndex
          });
        }
      });

      this.chart.on("mouseout", () => {
        this.chart.dispatchAction({
          type: "downplay"
        });

        this.chart.dispatchAction({
          type: "hideTips"
        });

        this.timer = this.$util.autoHighlightBar(this.chart, this.chargeData.length, 0, this.timer);
      });
    },
    openGasVide(mc){
      if(this.gasCameraList && this.gasCameraList.length > 0){
        this.$refs['gasMultiLiveVideo'].open({
          url: "",
          name: mc,
          videoList: this.gasCameraList
        });
      }
    },
    getGasCameraList(gasCode){
      return new Promise(resolve => {
        this.$api.getGasCameraList({gasCode: gasCode}).then(res => {
          if(res.succeed){
            this.gasCameraList = res.data;
            this.gasCameraList.sort((a, b) => a.channelNo - b.channelNo);
          }
          resolve();
        }).catch(e=>{
          console.log(e);
          resolve();
        });
      });
    },
    async getData() {
      this.chart.showLoading({
        text: "加载中...",
        maskColor: "rgba(0,0,0,0)",
        fontSize: 26,
        fontWeight: "bold",
        fontFamily: "Alibaba PuHuiTi",
        textColor: "rgba(211, 238, 254,  1)"
      });

      await this.$api.getNatureGasTodayAmount().then(res => {
        this.gasTotal = res.data.data;
      });
      this.$api.getData_Map().then(async res => {
        if (res.succeed) {
          const today = new Date();
          const formattedDate = today.toISOString().slice(0, 10);
          const gfData = [];
          await this.$api.getDayStatistics({statisticsDate: formattedDate}).then(gfRes => {
            if (gfRes.data) {
              gfRes.data.forEach(item => {
                gfData.push({
                  ...item,
                  fl: "光伏站",
                  dz: item.address,
                  mc: item.name,
                  jd: item.longitude,
                  wd: item.latitude,
                  zt: "正常",
                  cd: item.id,
                  jrsj: item.kwh
                })
              })
            }
          }).catch(e => {
            console.log(e)
          })
          let displayData = res.data;
          if(gfData && gfData.length > 0){
             displayData = displayData.concat(gfData);
          }
          this.disposeData(displayData);
          this.$emit("loadData", this.sourceData);
        }
      });
    },
    disposeData(sourceData) {
      const dataList = [];
      sourceData.forEach(item => {
        dataList.push({
          ...item,
          id: item.id,
          type: item.fl,
          address: item.dz,
          name: item.mc,
          value: [parseFloat(item.jd), parseFloat(item.wd), 0.5, item.zt],
          status: item.zt,
          company: item.scgs
        });
      });
      this.gfStation = dataList.filter(item => item.type === '光伏站');
      this.chargeData = dataList.filter(item => item.type === "充电站");
      this.gasolineData = dataList.filter(item => item.type === "加油站");
      this.gasData = dataList.filter(item => item.type === "加气站" && !item.cd);
      this.converterStation = dataList.filter(item=>item.type === "换电站");
      this.fireGasStation = dataList.filter(item=>item.type === '加气站' && item.cd === '-1');
      this.fireGasStation.map(item => item.jrsj = this.gasTotal);
      this.renderChart();
    },
    renderChart() {
      this.chart.hideLoading();

      const icon_charge_on = require("../../assets/image/icon_charge_on.png");
      const icon_charge_un = require("../../assets/image/icon_charge_un.png");

      const icon_gasoline_on = require("../../assets/image/icon_gasoline_on.png");
      const icon_gasoline_un = require("../../assets/image/icon_gasoline_un.png");

      const icon_gas_on = require("../../assets/image/icon_gas_on.png");
      const icon_gas_un = require("../../assets/image/icon_gas_un.png");

      const icon_fire_on = require("../../assets/image/icon_fire_on.png")
      const icon_photovoltaic_on = require("../../assets/image/icon_photovoltaic_on.png");

      const areaBg = document.createElement("img");
      areaBg.src = require("../../assets/image/bg_map_area.png");

      const symbolSize = 60;

      let options = {
        color: ["#70A2D8", "#CB8A56"],
        legend: {
          show: true,
          top: 130,
          right: 120,
          orient: "vertical",
          itemGap: 30,
          itemWidth: 60,
          itemHeight: 60,
          textStyle: {
            color: "#D0EBFE",
            fontSize: 28,
            fontFamily: "Alibaba PuHuiTi",
            fontWeight: "bold",
            padding: 2
          },
          data: [
            {
              name: "充电站",
              icon: "image://" + icon_charge_on
            },
            {
              name: "加油站",
              icon: "image://" + icon_gasoline_on
            },
            {
              name: "加气站",
              icon: "image://" + icon_gas_on
            },
            {
              name: "换电站",
              icon: "image://" + icon_conver_on
            },
            {
              name: "燃气站",
              icon: "image://" + icon_fire_on
            },
            {
              name: "光伏站",
              icon: "image://" + icon_photovoltaic_on
            }
          ]
        },
        tooltip: {
          show: true,
          trigger: "item",
          className: "echarts-tooltip",
          extraCssText: "padding: 20px 30px",
          formatter: function ({data}) {
            let titleColor = "";
            let saleUnit = "";
            switch (data.type) {
              case "充电站":
                titleColor = "green";
                saleUnit = "kwh";
                break;
              case "加油站":
                titleColor = "blue";
                saleUnit = "吨";
                break;
              case "加气站":
                titleColor = "cyan";
                saleUnit = "方";
                break;
              case "换电站":
                titleColor = "green";
                saleUnit = "kwh";
                break;
              case "光伏站":
                titleColor = "yellow";
                saleUnit = "kwh";
                break;
              case "燃气站":
                titleColor = "green";
                saleUnit = "方";
                break;
            }
            return `<div class='title ${titleColor}'>${data.name}</div>
                    <div class='address'>${data.address}</div>
                    <div class='status'>状态：${data.status}</div>
                    <div class='sale'>今日销量：${data.jrsj || '暂无'} ${data.jrsj ? saleUnit : ''}</div>
					         `;
          }
        },
        geo: {
          show: true,
          map: "geoMapYN_child",
          tooltip: {
            show: false
          },
          label: {
            show: true,
            color: "rgba(211, 238, 254, 1)",
            distance: 0,
            textStyle: {
              fontSize: 22
            },
            emphasis: {
              color: "rgba(211, 238, 254, 1)",
              distance: 0,
              textStyle: {
                fontSize: 22
              }
            }
          },
          roam: true,
          itemStyle: {
            normal: {
              areaColor: "rgba(0, 107, 255, 0.3)",
              borderColor: "#006BFF",
              borderWidth: 2
            },
            emphasis: {
              areaColor: "rgba(0, 107, 255, 0.3)",
              borderColor: "#006BFF",
              borderWidth: 2
            }
          }
        },
        series: [
          {
            type: "scatter",
            name: "充电站",
            tooltip: {
              show: true
            },
            coordinateSystem: "geo",
            data: this.chargeData,
            silent: false,
            symbolSize: symbolSize,
            symbol: (d) => {
              if (d[3] === "正常") {
                return "image://" + icon_charge_on;
              } else {
                return "image://" + icon_charge_un;
              }
            },
            symbolOffset: [0, "-30%"],
            emphasis: {
              scale: 2
            },
            selectedMode: "single"
          },
          {
            type: "scatter",
            name: "加油站",
            tooltip: {
              show: true
            },
            coordinateSystem: "geo",
            data: this.gasolineData,
            silent: false,
            symbolSize: symbolSize,
            symbol: (d) => {
              if (d[3] === "正常") {
                return "image://" + icon_gasoline_on;
              } else {
                return "image://" + icon_gasoline_un;
              }
            },
            emphasis: {
              scale: 2
            },
            selectedMode: "single"
          },
          {
            type: "scatter",
            name: "加气站",
            tooltip: {
              show: true
            },
            coordinateSystem: "geo",
            data: this.gasData,
            silent: false,
            symbolSize: symbolSize,
            symbol: (d) => {
              if (d[3] === "正常") {
                return "image://" + icon_gas_on;
              } else {
                return "image://" + icon_gas_un;
              }
            },
            emphasis: {
              scale: 2
            },
            selectedMode: "single"
          },
          {
            type: "scatter",
            name: "换电站",
            tooltip: {
              show: true
            },
            coordinateSystem: "geo",
            data: this.converterStation,
            silent: false,
            symbolSize: symbolSize,
            symbol: (d) => {
              if (d[3] === "正常") {
                return "image://" + icon_conver_on;
              } else {
                return "image://" + icon_conver_on;
              }
            },
            emphasis: {
              scale: 2
            },
            selectedMode: "single"
          },
          {
            type: "scatter",
            name: "燃气站",
            tooltip: {
              show: true
            },
            coordinateSystem: "geo",
            data: this.fireGasStation,
            silent: false,
            symbolSize: symbolSize,
            symbol: (d) => {
                return "image://" + icon_fire_on;
            },
            emphasis: {
              scale: 2
            },
            selectedMode: "single"
          },
          {
            type: "scatter",
            name: "光伏站",
            tooltip: {
              show: true
            },
            coordinateSystem: "geo",
            data: this.gfStation,
            silent: false,
            symbolSize: symbolSize,
            symbol: (d) => {
              return "image://" + icon_photovoltaic_on;
            },
            emphasis: {
              scale: 2
            },
            selectedMode: "single"
          }
        ]
      };

      this.chart.setOption(options);

      this.timer = this.$util.autoHighlightBar(this.chart, this.chargeData.length, 0, this.timer, true);
      this.bindEvents();
    }
  }
};
</script>

<style scoped lang="scss">
.chart {
  //transform-style: preserve-3d;
  //transform:  rotateX(45deg)  rotateY(0deg) rotateZ(-10deg);
}

.map-img {
  position: absolute;
  top: 47px;
  left: 133px;
  z-index: 1;
  width: 1356px;
  height: 1285px;
}

</style>
